import { createSelector } from '@reduxjs/toolkit';
import { selectSuperSimplifierDetails } from '../../store/selectors';

export const selectContributionDetails = createSelector(
  selectSuperSimplifierDetails,
  (superSimplifierDetails) => superSimplifierDetails.contributionDetails.details
);
